// extracted by mini-css-extract-plugin
export default {"spinner":"RestaurantManagement_spinner__Z46zM","arrow":"RestaurantManagement_arrow__yKdKn","active":"RestaurantManagement_active__pGoaJ"};